// extracted by mini-css-extract-plugin
export var productImage = "_lq-1";
export var viewLink = "_lq-2";
export var wishlistItem = "_lq-0";